import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticStringCreationComponent } from '../automatic-string-creation/automatic-string-creation.component';

@Component({
  selector: 'app-automatic-serial-creation',
  templateUrl: './automatic-serial-creation.component.html',
  styleUrls: ['./automatic-serial-creation.component.css']
})
export class AutomaticSerialCreationComponent {

  constructor(public dialog: MatDialog){

  }

  openDialog1(): void {
      this.dialog.open(AutomaticStringCreationComponent, {
    }); 
  }
  
}
